'use strict';

import axios from 'axios';
import { CLIENT_API_URL } from '../../../constants/Environment';
import { BUSINESS_ID_RECTIFICATION } from '@/constants/ConfigurationConstants';

const parseDetail = raw => {
  const d = raw.detail ?? raw.Detail;
  if (typeof d === 'string') return JSON.parse(d);
  return d ?? null;
};

const normalize = p => ({
  id:                p.id                ?? p.Id                ?? null,
  businessId:        p.businessId        ?? p.BusinessId        ?? null,
  client:            p.client            ?? p.Client            ?? null,
  detail:            parseDetail(p),
  currencyCode:      p.currencyCode      ?? p.CurrencyCode      ?? 'BOB',
  creationDate:      p.creationDate      ?? p.CreationDate      ?? null,
  servicesDiscount:  p.servicesDiscount  ?? p.ServicesDiscount  ?? 0,
  createdBy:         p.createdBy         ?? p.CreatedBy         ?? '',
  createdById:       p.createdById       ?? p.CreatedById       ?? null,
  note:              p.note              ?? p.Note              ?? '',
  convertedAt:       p.convertedAt       ?? p.ConvertedAt       ?? null,
  convertedToOrderId: p.convertedToOrderId ?? p.ConvertedToOrderId ?? null
});

const retrieveAllPreOrders = async ({ dispatch, commit }) => {
  dispatch('loading/setIsPreOrderLoading', true, { root: true });
  try {
    const response = await axios.get(
      `${CLIENT_API_URL}/pre-orders?businessId=${BUSINESS_ID_RECTIFICATION}`
    );
    commit('setAllPreOrders', response.data.map(normalize));
  } catch (error) {
    console.error('Error retrieving pre-orders: ' + error);
  } finally {
    dispatch('loading/setIsPreOrderLoading', false, { root: true });
  }
};

const addPreOrder = async ({ commit }, preOrderData) => {
  const payload = {
    ...preOrderData,
    detail: typeof preOrderData.detail === 'object'
      ? JSON.stringify(preOrderData.detail)
      : preOrderData.detail
  };
  const response = await axios.post(`${CLIENT_API_URL}/pre-orders`, payload);
  const preOrder = normalize(response.data);
  commit('addPreOrder', preOrder);
  return preOrder;
};

const updatePreOrder = async ({ commit }, { id, preOrderData }) => {
  const payload = {
    ...preOrderData,
    detail: typeof preOrderData.detail === 'object'
      ? JSON.stringify(preOrderData.detail)
      : preOrderData.detail
  };
  const response = await axios.put(`${CLIENT_API_URL}/pre-orders/${id}`, payload);
  const preOrder = normalize(response.data);
  commit('updatePreOrder', preOrder);
  return preOrder;
};

const convertPreOrder = async ({ commit }, id) => {
  const response = await axios.post(`${CLIENT_API_URL}/pre-orders/${id}/convert`);
  const preOrder = normalize(response.data);
  commit('updatePreOrder', preOrder);
  return preOrder;
};

const removePreOrder = async ({ commit }, id) => {
  await axios.delete(`${CLIENT_API_URL}/pre-orders/${id}`);
  commit('removePreOrder', id);
};

export default {
  retrieveAllPreOrders,
  addPreOrder,
  updatePreOrder,
  convertPreOrder,
  removePreOrder
};
